import Typography, { TypographyVariant } from '@ben/orion/typography';
import { memo } from 'react';
import styled, { css } from 'styled-components';

interface IModularBenefitComponentWrapper {
  children: React.ReactNode;
  showTitle?: boolean;
  title?: string;
  wrapChildren?: boolean;
}

const ModularBenefitComponentWrapper = ({
  children,
  showTitle,
  title,
  wrapChildren = true,
}: IModularBenefitComponentWrapper) => {
  return (
    <Container>
      {showTitle && title && (
        <Typography variant={TypographyVariant.bodyLg2}>{title}</Typography>
      )}
      {wrapChildren ? (
        <ComponentContainer>{children}</ComponentContainer>
      ) : (
        children
      )}
    </Container>
  );
};

export default memo(ModularBenefitComponentWrapper);

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing(2)};
    flex-direction: column;
  `}
`;

const ComponentContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    border: 1px solid ${theme.palette.neutral[60]};
    border-radius: ${theme.borderRadius.sm};
    padding: ${theme.spacing(3, 4, 3, 4)};
  `}
`;
